export const PaymentEndpoints = Object.freeze({
  /**
   * This endpoint accepts username inside the body and checks if the
   * username is valid
   *
   * if valid -> return the user's firstName and lastName
   *
   * if valid & user does not set firstName or lastName -> returns back the username itself
   *
   * @body username 		String
   * @body plan_id     	Number
   *
   * @returns API Endpoint string
   */
  PaymentDetails: '/v3/public/plan/detail',

  /**
   * @body username       String
   * @body plan_id        Number
   * @body plan_price_id  Number
   * @body gateway_id     Number
   *
   * @returns API Endpoint string
   */
  SubscribeZarinPal: `/v3/payments/purchasePlan/zarinpal`,
  SubscribeIPG: `/v3/payments/purchasePlan/ipg`,
  VerifyZarinpalPayment: '/v3/payments/purchasePlan/zarinpal/verify',
  VerifyIPGPayment: '/v3/payments/purchasePlan/ipg/verify',
  VerifyDiscountCode: ({
    username,
    discountCode,
    planId
  }: {
    discountCode: string
    username: string
    planId: string
  }) =>
    `/v3/payments/discountCode?discountCode=${discountCode}&username=${username}&planId=${planId}`,
  TransactionsList: '/v3/user/payments',
  DirectDebitVerify: '/v3/payments/directDebit/verify',
  DirectDebitPay: '/v3/payments/directDebit',
  GetBanks: '/v3/payments/directDebit/banks',
  getDirectDebitPayments: (planId: string) => `/v3/payments/directDebit/${planId}`,
  CancelDirectDebit: '/v3/payments/directDebit/cancel'
})
